import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

export function useTranslation() {
  const { currentLanguage } = useLanguage();
  
  const translate = (key) => {
    return t(key, currentLanguage);
  };
  
  return { t: translate, currentLanguage };
}

export default useTranslation;
